/* eslint-disable no-param-reassign */
/* @ngInject */

export default (
  $anchorScroll,
  $q,
  $rootScope,
  $scope,
  $location,
  $timeout,
  $stateParams,
  $window,
  webpage,
  accountService,
  slackService,
  eventService,
  changesService,
  uiService
) => {
  $scope.Model = {
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  $q.all([accountService.readAccount({ id: $rootScope.CurrentAccount.id })])
    .then((data) => {
      // Overwrite $rootScope values in case they've reverted to values within Token
      $rootScope.CurrentAccount.userInterface = data[0].userInterface;
    })
    .then(() => {
      // Declare Model as Ready and start rendering the page
      webpage.pageTitle('My personalization : Settings');
      $scope.Model.isReady = true;
    });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.saveAccount = (data) => {
    if (data?.id && !_.isEmpty(data?.userInterface)) {
      $rootScope.CurrentAccount.userInterface = data.userInterface;
      changesService.change();
    }
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const accountData = {
      id: $rootScope.CurrentAccount.id,
      userInterface: $rootScope.CurrentAccount.userInterface
    };
    return accountService.updateAccount(accountData).then((result) => {
      if (result.status) {
        changesService.resetChanges();
        eventService.credentialsChanged();
        uiService.toast({
          text: {
            p1: 'Sign-out and then sign-in',
            p2: 'in order to apply',
            p3: 'your changes'
          },
          warn: true,
          delay: 4000
        });
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true,
          delay: 4000
        });
      }
      return { status: !!result.status };
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
